import { FC, ReactNode } from 'react';

import styles from './MortgageContent.module.scss';

interface DocumentsContentProps {
  children: ReactNode;
}

const MortgageContent: FC<DocumentsContentProps> = ({ children }) => {
  return <div className={styles.content}>{children}</div>;
};

export default MortgageContent;
